import { render, staticRenderFns } from "./OrderValidationMessage.vue?vue&type=template&id=50e7d48c&"
import script from "./OrderValidationMessage.vue?vue&type=script&lang=js&"
export * from "./OrderValidationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports